

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 14"}, rest), ["\n  ", h('path', {"fill":"currentColor","fill-rule":"nonzero","d":"M8.1.4c.29.29.29.77 0 1.06L3.308 6.25h15.19c.41 0 .75.34.75.75s-.34.75-.75.75H3.31l4.79 4.79c.29.29.29.77 0 1.06-.14.15-.34.22-.53.22s-.38-.07-.53-.22L.97 7.53a.754.754 0 0 1 0-1.06L7.04.4c.29-.29.77-.29 1.06 0Z"}, []), "\n"]);
};

        